import { Action, Dispatch } from 'redux';
import { getAutoComplete } from 'services/ApiSearchService';
import { AutoCompleteSuggestion } from 'models/AutoCompleteSuggestion';
import { GtmSearch } from 'store/googleTagManager/actions';

export const SEARCH_MINIMUM_LENGTH = 3;

export const HEADER_SEARCH_SUBMIT = 'HEADER_SEARCH_SUBMIT';
export const HEADER_SEARCH_AUTO_DATA_LOADED = 'HEADER_SEARCH_AUTO_DATA_LOADED';
export const HEADER_SEARCH_AUTO_DATA_LOADING = 'HEADER_SEARCH_AUTO_DATA_LOADING';
export const HEADER_SEARCH_CLOSE = 'HEADER_SEARCH_CLOSE';
export const HEADER_SEARCH_OPEN = 'HEADER_SEARCH_OPEN';

export interface SearchAction extends Action {
  searchString: string;
  suggestion: AutoCompleteSuggestion;
}

export const searchAutocompleteDataLoaded = (
  searchSuggestions?: AutoCompleteSuggestion | undefined
) => ({
  type: HEADER_SEARCH_AUTO_DATA_LOADED,
  suggestion: searchSuggestions
});

export const searchAutocompleteDataLoading = () => ({
  type: HEADER_SEARCH_AUTO_DATA_LOADING
});

export const searchClose = () => ({
  type: HEADER_SEARCH_CLOSE
});

export const searchOpen = () => ({
  type: HEADER_SEARCH_OPEN
});

export const searchAutocompleteFetchData = (searchString: string) => {
  return (dispatch: Dispatch) => {
    dispatch(searchAutocompleteDataLoading());
    return getAutoComplete(searchString).then((data: AutoCompleteSuggestion) => {
      dispatch(searchAutocompleteDataLoaded(data));
      if (searchString) {
        dispatch(GtmSearch(searchString, 'instant_search'));
      }
    });
  };
};
